__turbopack_context__.v({
  "container": "b8mqHa_container",
  "emptyItemList": "b8mqHa_emptyItemList",
  "header": "b8mqHa_header",
});
